// Network detection — backend's /api/health returns the configured
// network (testnet/mainnet); the frontend mirrors per-chain config
// derived from it. See `frontend/src/config/chains.ts`.

export type Network = "mainnet" | "testnet";

/**
 * Resolves the user-visible network slug. Priority:
 *   1. `VITE_OMNIBRIDGE_NETWORK` build-time env (`testnet` or `mainnet`)
 *   2. `localStorage.omnibridge_network` (set by tests / debug toggles)
 *   3. Default to `testnet`
 *
 * In production this is corrected by `/api/health` on first load — but
 * we ship a sensible default so the UI can render before the health
 * fetch resolves.
 */
export function defaultNetwork(): Network {
  const env = (import.meta.env.VITE_OMNIBRIDGE_NETWORK ?? "").toString();
  if (env === "mainnet" || env === "testnet") return env;
  if (typeof window !== "undefined") {
    const stored = window.localStorage?.getItem("omnibridge_network");
    if (stored === "mainnet" || stored === "testnet") return stored;
  }
  return "testnet";
}
